<template>
  <div>
    <DataTable :value="escalasHorarios" :filters="filtro" :paginator="true" :rows="10"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
        class="p-datatable-sm p-datatable-striped">
        <template #header>
            <div class="table-header">	
               <div class="p-d-flex p-jc-end">				
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                    </span>
                </div>
            </div>
        </template>
        <Column field="contrato.id" header="Código"></Column>
        <Column field="contrato.descricao" header="Escala"></Column>
        <Column field="contrato.tipo" header="Tipo">
            <template #body="slotProps">               
                {{slotProps.data.contrato.tipo === 1 ? 'Quadro de Horários' : 'Revezamento'}}
            </template>
        </Column>
        <Column field="dataInicio" header="Data início"></Column>
        <Column field="dataFinal" header="Data final"></Column>	        
        <Column>
            <template #body="slotProps">
                <div v-if="slotProps.data.dataFinal == null">
                    <Button icon="pi pi-plus" title="Nova Escala de Horários" class="p-button-rounded p-button-primary p-mr-2" @click="listarContratos('Novo')"/>
                    <Button icon="pi pi-pencil" title="Alterar/excluir Escala de Horários" class="p-button-rounded p-button-warning p-mr-2" @click="listarContratos('Alterar')"/>
                    <Button icon="pi pi-calendar" title="Alterar data de início" class="p-button-rounded p-button-primary p-mr-2" @click="listarContratos('DataInicio')"/>	
                </div>                						
            </template>
        </Column>
    </DataTable>

    <Button label="Fechar" class="p-button-secondary p-mt-3" icon="pi pi-times" @click="cancelar"/>

    <Dialog :visible.sync="exibirDialogNovaEscala" header="Nova Escala de Horários" :modal="true" class="p-fluid" :style="{width: '500px'}">			
        <div class="p-fluid p-formgrid p-grid">		
            <div class="p-field p-col-12 p-md-12">
                <label>Escala atual</label>							
                <InputText v-model="funcionarioContratoAtual.contrato.descricao" readonly/>							
            </div>			
            <div class="p-field p-col-12 p-md-12">
                <label>Nova escala de horários</label>							
                <Dropdown v-model="idContratoSelecionado" :filter="true" :options="contratos" 
                optionLabel="descricao" optionValue="refId" dataKey="refId" appendTo="body"/>								
            </div>
            <div class="p-field p-col-12 p-md-12">
                <label for="dataInicioContrato">Data de início</label>
                <Calendar id="dataInicioContrato" v-model="dataInicioContrato" :showIcon="true" :manualInput="false" required="true" dateFormat="dd/mm/yy" appendTo="body"/>	
            </div>
        </div>
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Salvar" icon="pi pi-check" @click="trocarContrato"/>
        </template>
    </Dialog>

    <Dialog :visible.sync="exibirDialogExcluirHistoricoEscala" header="Alterar/excluir Escala de Horários" :modal="true" class="p-fluid" :style="{width: '500px'}">			
        <div class="p-fluid p-formgrid p-grid">		
            <div class="p-field p-col-12 p-md-12">
                <label>Escala atual</label>							
                <InputText v-model="funcionarioContratoAtual.contrato.descricao" readonly/>							
            </div>			
            <div class="p-field p-col-12 p-md-12">
                <label>Nova escala de horários</label>							
                <Dropdown v-model="idContratoSelecionado" :filter="true" :options="contratos" 
                optionLabel="descricao" optionValue="refId" dataKey="refId" appendTo="body"/>								
            </div>
            <div class="p-field p-col-12 p-md-12">
                <label for="dataInicioContrato">Data de início</label>
                <Calendar id="dataInicioContrato" v-model="funcionarioContratoAtual.dataInicio" :showIcon="true" :manualInput="false" required="true" dateFormat="dd/mm/yy" appendTo="body"  disabled=""/>	
            </div>
        </div>
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Salvar" icon="pi pi-check"  @click="trocarExcluirContrato"/>
        </template>
    </Dialog>

    <Dialog :visible.sync="exibirDialogAlterarData" header="Alterar Data de Início" :modal="true" class="p-fluid" :style="{width: '500px'}">			
        <div class="p-fluid p-formgrid p-grid">		
            <div class="p-field p-col-12 p-md-12">
                <label>Escala atual</label>							
                <InputText v-model="funcionarioContratoAtual.contrato.descricao" readonly/>							
            </div>
            <div class="p-field p-col-12 p-md-12">
                <label for="dataInicioContrato">Data de início</label>
                <Calendar id="dataInicioContrato" v-model="dataInicioContrato" :showIcon="true" :manualInput="false" required="true" dateFormat="dd/mm/yy" appendTo="body"/>	
            </div>
        </div>
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Salvar" icon="pi pi-check" @click="alterarDataInicioContrato"/>
        </template>
    </Dialog>

  </div>
</template>

<script>
import FuncionarioService from '@/service/FuncionarioService';
import FuncionarioPesquisaService from '@/service/FuncionarioPesquisaService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    props: {
        escalasHorarios: {
            type: Array,
            required: true,
            default: function() {
                return [];
            }
        },
        funcionario: {
            type:Object,
            required: true,
            default: function() {return {}}
        },
        cnpj: {
            type:Object,
            required: true,
            default: function() {return {}}
        },
        callback: {
            type: Function,
            required: true,
        }
    },
    funcionarioService: null,
	funcionarioPesquisaService: null,
    data() {
        return {       
            exibirDialogNovaEscala: false,
            exibirDialogExcluirHistoricoEscala: false,
            exibirDialogAlterarData: false,
            idContratoSelecionado: null,
            contratos: [],     
            funcionarioContratoAtual: {contrato:{descricao: ''}},
            contratroSelecionado: {},
            dataInicioContrato: new Date(),
            filtro: {},
        }
    },
    methods: {        
        ...mapGetters('sessao', ['getDadosRequisicao']), 
        trocarContrato() {
            for(let i = 0; i < this.contratos.length; i++) { 
                if(this.idContratoSelecionado == this.contratos[i].refId) {
                    this.contratroSelecionado = this.contratos[i];   
                    break;
                }
            }          
            let funcionario = {...this.funcionario};
            funcionario.dataNascimento = this.formatarData(funcionario.dataNascimento);
			funcionario.dataCadastro = this.formatarData(funcionario.dataCadastro);
			funcionario.dataFinal = this.formatarData(funcionario.dataFinal);
			funcionario.dataAdmissao = this.formatarData(funcionario.dataAdmissao);
			funcionario.dataDemissao = this.formatarData(funcionario.dataDemissao); 
            funcionario.dataAtivacao = this.formatarData(funcionario.dataAtivacao); 
            funcionario.pis = funcionario.pis.replace('-', '').replace('.', '').replace('.', '');
            funcionario.cpf = (funcionario.cpf ? funcionario.cpf.replace('-', '').replace('.', '').replace('.', '') : funcionario.cpf);
            let requisicao = {
                cnpj: this.cnpj,
                funcionario: funcionario,
                contrato: {...this.contratroSelecionado},
                dataInicio: this.formatarData(this.dataInicioContrato),
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.funcionarioService.trocarContrato(requisicao)
				.then(resp => {      
                    exibirMensagem(this, resp);
                    this.fecharModal();
                    this.callback();
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        trocarExcluirContrato() {
            for(let i = 0; i < this.contratos.length; i++) { 
                if(this.idContratoSelecionado == this.contratos[i].refId) {
                    this.contratroSelecionado = this.contratos[i];   
                    break;
                }
            }       
            let funcionarioContratoAtual = {...this.funcionarioContratoAtual};
            funcionarioContratoAtual.dataInicio = this.formatarData(funcionarioContratoAtual.dataInicio);
            funcionarioContratoAtual.dataFinal = this.formatarData(funcionarioContratoAtual.dataFinal);
            let funcionario = {...this.funcionario};
            funcionario.dataNascimento = this.formatarData(funcionario.dataNascimento);
			funcionario.dataCadastro = this.formatarData(funcionario.dataCadastro);
			funcionario.dataFinal = this.formatarData(funcionario.dataFinal);
			funcionario.dataAdmissao = this.formatarData(funcionario.dataAdmissao);
			funcionario.dataDemissao = this.formatarData(funcionario.dataDemissao);   
            funcionario.dataAtivacao = this.formatarData(funcionario.dataAtivacao);   
            funcionario.pis = funcionario.pis.replace('-', '').replace('.', '').replace('.', '');
            funcionario.cpf = (funcionario.cpf ? funcionario.cpf.replace('-', '').replace('.', '').replace('.', '') : funcionario.cpf);
            let requisicao = {
                cnpj: this.cnpj,
                funcionario: funcionario,
                funcionarioContratoAtual: funcionarioContratoAtual,
                funcionarioContratoNovo: {
                    contrato: {...this.contratroSelecionado},
                    dataInicio: this.formatarData(this.funcionarioContratoAtual.dataInicio),
                },
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.funcionarioService.trocarExcluirContrato(requisicao)
				.then(resp => {      
                    exibirMensagem(this, resp);
                    this.fecharModal();
                    this.callback();
                })
                .catch(erro => {exibirMensagem(this, erro)});
        }, 
        alterarDataInicioContrato() {
            for(let i = 0; i < this.contratos.length; i++) { 
                if(this.idContratoSelecionado == this.contratos[i].refId) {
                    this.contratroSelecionado = this.contratos[i];   
                    break;
                }
            }    
            let funcionarioContratoDataInicio = {...this.funcionarioContratoAtual};
            funcionarioContratoDataInicio.dataInicio = this.formatarData(this.dataInicioContrato);
            let funcionario = {...this.funcionario};
            funcionario.dataNascimento = this.formatarData(funcionario.dataNascimento);
			funcionario.dataCadastro = this.formatarData(funcionario.dataCadastro);
			funcionario.dataFinal = this.formatarData(funcionario.dataFinal);
			funcionario.dataAdmissao = this.formatarData(funcionario.dataAdmissao);
			funcionario.dataDemissao = this.formatarData(funcionario.dataDemissao);
            funcionario.dataAtivacao = this.formatarData(funcionario.dataAtivacao);  
            funcionario.pis = funcionario.pis.replace('-', '').replace('.', '').replace('.', '');
            funcionario.cpf = (funcionario.cpf ? funcionario.cpf.replace('-', '').replace('.', '').replace('.', '') : funcionario.cpf);       
            let requisicao = {         
                cnpj: this.cnpj,
                funcionario: funcionario,      
                funcionarioContratoAtual: funcionarioContratoDataInicio,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.funcionarioService.alterarDataInicioContrato(requisicao)
				.then(resp => {      
                    exibirMensagem(this, resp);
                    this.fecharModal();
                    this.callback();
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },       
        fecharModal() {
            this.exibirDialogNovaEscala = false;
            this.exibirDialogExcluirHistoricoEscala = false;
            this.exibirDialogAlterarData = false;
        },
        listarContratos(acao) {
			let usuarioRequisicao = {...this.getDadosRequisicao()};         
            this.funcionarioPesquisaService.listarContratos(usuarioRequisicao)
				.then(resp => {                   
                    for(let i = 0; i < this.escalasHorarios.length; i++) {
                        if(this.escalasHorarios[i].dataFinal == null) {
                            this.funcionarioContratoAtual = this.escalasHorarios[i];                            
                            break;
                        }
                    }
					this.contratos = resp.data;
                    this.contratos.forEach((contrato, i) => {
                        contrato['refId'] = i + '_' + contrato.id;
                    });
                    this.idContratoSelecionado = this.contratos[0].refId;
                    if(acao == 'Novo') {
                        this.exibirDialogNovaEscala = true;            
                    } else if(acao == 'Alterar') {
                        this.exibirDialogExcluirHistoricoEscala = true;
                    } else {// data inicio
                        this.exibirDialogAlterarData = true;
                    }
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        cancelar() {
            this.$router.push('/cadastros/funcionarios');
        },
    },	
	created() {
        this.funcionarioService = new FuncionarioService();	
        this.funcionarioPesquisaService = new FuncionarioPesquisaService();	
	}
}
</script>

<style>

</style>